import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SalonFooter = ({ isMobile = false }) => {
  const navigate = useNavigate();

  const handleBookingBarberClick = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        mt: 4,
        py: 3,
        px: 2,
        textAlign: 'center',
        borderTop: '1px solid #E5E7EB',
        backgroundColor: '#F8F9FA'
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: '#6B7280',
          fontSize: '0.75rem',
          lineHeight: 1.5
        }}
      >
        Cette page de réservation a été créée par{' '}
        <Link
          component="button"
          onClick={handleBookingBarberClick}
          sx={{
            color: '#000000',
            fontWeight: 600,
            textDecoration: 'none',
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          BookingBarber
        </Link>
      </Typography>
    </Box>
  );
};

export default SalonFooter;